// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlurChat__container-abff48 {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--addition-40_35);
  color: var(--addition-50);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.BlurChat__label-b1bc48 {
  margin: 16px 0;
  max-width: 300px;
  text-align: center;
}

.BlurChat__icon-ed4dbc {
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/BlurChat/BlurChat.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,mCAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,yBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  -webkit-backdrop-filter: blur(30px);\n  backdrop-filter: blur(30px);\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--addition-40_35);\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.label {\n  margin: 16px 0;\n  max-width: 300px;\n  text-align: center;\n}\n\n.icon {\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BlurChat__container-abff48`,
	"label": `BlurChat__label-b1bc48`,
	"icon": `BlurChat__icon-ed4dbc`
};
module.exports = ___CSS_LOADER_EXPORT___;
